import React from 'react';

import LogoBankID from './icons/icon-bankid.js';
import IconOdds from './icons/icon-odds.js';
import IconLock from './icons/icon-lock.js';
import IconLegalBookie from './icons/icon-legal-bookie-logo.js';
import IconSelfAssessment from './icons/icon-self-assessment.js';
import IconTrustly from './icons/icon-trustly.js';
import LogoEquifax from './icons/icon-equifax.js';
import LogoFintrac from './icons/icon-fintrac.js';
import IconGoogle from './icons/icon-google.js';
import IconFacebook from './icons/icon-facebook.js';

import { Constants as FlagLogoConstants, LOGO_MAPPING as FlagLogoMapping } from './flags/index.js';
import {
	POLISH_LOGOS_CONSTANTS as PolishLogosConstants,
	LOGO_MAPPING as PolishLogosMapping
} from './payment-logos/polish-logos.js';
import {
	MISC_LOGOS_CONSTANTS as MiscLogosConstants,
	MISC_LOGO_MAPPING as MiscLogosMapping
} from './payment-logos/misc-logos.js';

const Logos = { ...FlagLogoMapping, ...PolishLogosMapping, ...MiscLogosMapping };
const Constants = {
	...FlagLogoConstants,
	...PolishLogosConstants,
	...MiscLogosConstants
};

export const Null = () => null;
export const logoWrapperMapper = WrapperComponent => {
	return item => {
		const Logo = Logos[item];
		return (
			<WrapperComponent data-at={item} key={item}>
				<React.Suspense fallback={<Null />}>
					<Logo />
				</React.Suspense>
			</WrapperComponent>
		);
	};
};

export { Logos, Constants };
export {
	LogoBankID,
	IconOdds,
	IconLock,
	IconLegalBookie,
	IconSelfAssessment,
	IconTrustly,
	LogoEquifax,
	LogoFintrac,
	IconGoogle,
	IconFacebook
};
export * from './payment-logos/externals.js';
export * from './flags/flags.js';
export * from './misc/async.js';
